
export const smartRound = (value: number, precision: number) => {
    try {
        const factor = Math.pow(10, precision);
        const newVal = Math.round(value * factor) / factor;
        
        // console.log('value', value, 'precision', precision, 'newVal', newVal);
        return newVal;
    } catch (error) {
        console.warn('Error in smartRound:', error);
        return value; // Return the original value in case of error
    }
};